(() => {
  const config = window.TreffenPolicies || {};
  const hubUrl = config.hubUrl || '/pages/policies';

  function normalizePath(pathname) {
    return pathname.replace(/\/+$/, '') || '/';
  }

  function buildHubUrl(tabHandle, tabQuery) {
    const base = hubUrl.split('#')[0].split('?')[0];
    const url = new URL(base, window.location.origin);
    if (tabQuery) url.searchParams.set('tab', tabQuery);
    if (tabHandle) url.hash = tabHandle;
    return `${url.pathname}${url.search}${url.hash}`;
  }

  function isHubPage(pathname) {
    try {
      const hubPath = normalizePath(new URL(hubUrl, window.location.origin).pathname);
      return normalizePath(pathname) === hubPath;
    } catch (error) {
      return normalizePath(pathname) === normalizePath(hubUrl);
    }
  }

  function handlePoliciesMenuClick(event) {
    const link = event.target.closest('a[data-policy-tab]');
    if (!link || link.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const tab = link.dataset.policyTab;
    const tabQuery = link.dataset.policyTabQuery;
    if (!tab) return;

    event.preventDefault();
    event.stopPropagation();

    if (isHubPage(window.location.pathname)) {
      const policyTabs = document.querySelector('policy-tabs');
      const targetTab =
        (tabQuery && policyTabs?.querySelector(`[data-tab-id="${tabQuery}"]`)) ||
        policyTabs?.querySelector(`[data-tab-handle="${tab}"]`);

      if (policyTabs && targetTab && typeof policyTabs.activateTab === 'function') {
        policyTabs.activateTab(targetTab, false, true, true);
        return;
      }
    }

    window.location.href = buildHubUrl(tab, tabQuery);
  }

  function initPolicyLinks() {
    document.querySelectorAll('.treffen-footer__menu--policies').forEach((menu) => {
      menu.addEventListener('click', handlePoliciesMenuClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPolicyLinks);
  } else {
    initPolicyLinks();
  }
})();
